/**
 * Reads a multi-value form field stored as a string array or a JSON string array.
 */
export function storedStringList(value: unknown): string[] {
	if (Array.isArray(value)) {
		return value.filter((entry): entry is string => typeof entry === "string");
	}
	if (typeof value !== "string") return [];
	const trimmed = value.trim();
	if (!trimmed.startsWith("[")) return [];
	try {
		const parsed = JSON.parse(trimmed) as unknown;
		if (!Array.isArray(parsed)) return [];
		return parsed.filter((entry): entry is string => typeof entry === "string");
	} catch {
		return [];
	}
}
